import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initSentry } from "@/lib/sentry";

// STARSEED-CAPMARKETS-026 — no-op unless REACT_APP_SENTRY_DSN was baked in
// at build time; init before first render so render errors are captured.
initSentry();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
